import React from 'react';
import { Box, Typography } from '@mui/material';
import ValidSecurity from './Security';

/**
 * Security Page - Standalone route for security/role management
 * Previously a tab in the Admin component
 */
export default function SecurityPage() {
  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Security & Roles
      </Typography>
      <ValidSecurity />
    </Box>
  );
}
